(function () {
  const initAnimation = (section) => {
    if (
      !section ||
      !section.classList.contains("social-media-section") ||
      !section.querySelector(".animate-on-scroll")
    )
      return;

    const text = section.querySelector(".social-media-content__main-text");

    if (!text) return;

    ScrollTrigger.create({
      trigger: text,
      start: "50% 95%",
      end: "bottom top",
      onEnter: () => text.classList.add("animated"),
    });
  };

  const initSlider = (section) => {
    if (!section?.classList.contains("social-media-section")) return;

    const slider = section.querySelector(".social-media-slider");
    if (!slider) return;

    const speed = Math.max(+slider.dataset.speed * 1000, 100);

    window.theme.initContinuousMarquee(slider, {
      speed,
      gap: 8,
      stopOnHover: slider.dataset.stopOnHover === "true",
      marqueeCopies: +slider.dataset.marqueeCopies || 2,
    });
  };

  const addRichTextLinksArrows = (section) => {
    if (!section?.classList.contains("social-media-section")) return;

    const richTextLinks = section.querySelectorAll(
      `.social-media-content__main-text a`
    );

    if (!richTextLinks.length) {
      return;
    }

    const richTextArrow =
      '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 28.4848L28.4821 4M28.4821 4H6.49748M28.4821 4V25.9846" stroke="#7B7F84" stroke-width="2" stroke-linecap="square"/></svg>';

    richTextLinks.forEach((link) => {
      if (link.querySelector(".social-media-content__main-text-arrows")) {
        return;
      }

      const richTextLinkText = link.textContent;
      link.dataset.label = richTextLinkText;

      const arrowWrapper = document.createElement("span");
      arrowWrapper.classList.add("social-media-content__main-text-arrows");
      arrowWrapper.innerHTML =
        '<span class="social-media-content__main-text-arrows-wrapper">' +
        richTextArrow +
        richTextArrow +
        "</span>";
      link.appendChild(arrowWrapper);
    });
  };

  const initAll = (root = document) => {
    const sections =
      root instanceof Element && root.matches(".social-media-section")
        ? [root]
        : root.querySelectorAll(".social-media-section");

    sections.forEach((section) => {
      addRichTextLinksArrows(section);
      initSlider(section);
      initAnimation(section);
    });
  };

  const scriptSection = window.theme.getSectionFromCurrentScript(
    "social-media-section"
  );

  if (scriptSection) {
    addRichTextLinksArrows(scriptSection);
    initSlider(scriptSection);
    initAnimation(scriptSection);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
